import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "no_border_row"
};
import { Formatter } from "@/util/Formatter";
import { CartItem } from "@/model/CartItem";
import { PriceType } from "@/model/enum/PriceType.model";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ItemContentRow',
    props: {
        cartItem: { type: CartItem, required: false },
        orderItem: { type: Object, required: false },
        priceType: { type: String, required: true },
        label: { type: String, required: true },
        referenceId: { type: Number, required: false, default: null }
    },
    setup(__props) {
        const props = __props;
        function displayRow() {
            if (props.cartItem) {
                switch (props.priceType) {
                    case PriceType.FLAT_RATE:
                        return props.cartItem.product.priceStructure.isPricingByFlatrate() && props.cartItem.prices.has('FLAT_RATE');
                    case PriceType.PER_RESOURCE:
                        return true;
                }
            }
            if (props.orderItem) {
                switch (props.priceType) {
                    case PriceType.FLAT_RATE:
                        return props.orderItem.itemTotal.grossPrices.has('FLAT_RATE');
                    case PriceType.PER_RESOURCE:
                        return true;
                }
            }
            return false;
        }
        function getItemPrice() {
            let singlePrice;
            if (props.cartItem) {
                if (props.priceType === PriceType.PER_RESOURCE && !props.cartItem?.product.priceStructure.isPricingByResources()) {
                    return "";
                }
                singlePrice = props.cartItem.prices.get(props.priceType);
            }
            if (props.orderItem) {
                singlePrice = props.orderItem.itemTotal.grossPrices.get(props.priceType);
            }
            if (!singlePrice) {
                return "";
            }
            return Formatter.currency(singlePrice.get(props.referenceId));
        }
        function getQuantity() {
            let reservations = {};
            if (props.cartItem) {
                reservations = props.cartItem.resourceReservations;
            }
            else if (props.orderItem) {
                reservations = props.orderItem.reservations;
            }
            switch (props.priceType) {
                case PriceType.FLAT_RATE:
                    return "";
                case PriceType.PER_RESOURCE:
                    return reservations[props.referenceId] || 0;
            }
            return "";
        }
        function getItemSum() {
            if (props.cartItem) {
                if (props.priceType === PriceType.PER_RESOURCE && !props.cartItem.product.priceStructure.isPricingByResources()) {
                    return "";
                }
            }
            let prices = new Map();
            if (props.cartItem) {
                prices = props.cartItem.prices;
            }
            else if (props.orderItem) {
                prices = props.orderItem.itemTotal.grossPrices;
            }
            let itemSum;
            switch (props.priceType) {
                case PriceType.FLAT_RATE:
                    itemSum = prices.get('FLAT_RATE');
                    break;
                case PriceType.PER_RESOURCE:
                    itemSum = prices.get('resources');
                    break;
            }
            if (!itemSum) {
                return "";
            }
            return Formatter.currency(itemSum.get(props.referenceId));
        }
        return (_ctx, _cache) => {
            return (displayRow())
                ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                    _createElementVNode("td", null, _toDisplayString(__props.label), 1),
                    _createElementVNode("td", null, _toDisplayString(getItemPrice()), 1),
                    _createElementVNode("td", null, _toDisplayString(getQuantity()), 1),
                    _createElementVNode("td", null, _toDisplayString(getItemSum()), 1)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
